"use strict";

import $ from 'jquery';
import { articleTitle, authorsIDs, articleIDnbsp } from './render';

$(function () {
    const queryString = $('#pageSpecificScript').attr('data-queryString');

    $('#dataTable').DataTable({
        ajax: '/articles.json?' + queryString,
        columns: [
            { render: articleIDnbsp },
            { render: articleTitle },
            null,
            null,
            { render: authorsIDs },
            null,
        ],
    });
});
